import { Autocomplete } from '@material-ui/lab';
import { Chip, TextField, makeStyles } from '@material-ui/core';
import { Customer } from '../../../../model';
import { WikusAvatar } from '@wikus-ui/components/core/avatar';
import { WikusModelCard } from '@wikus-ui/components/complex/model-card';
import { filter } from 'lodash';
import { getInitials } from '@wikus-ui/utils';
import { useIntl } from 'react-intl';

const getOptionLabel = (option: any) => option.customerNumber;

const renderOption = (customer: any, intl: any) => (
  <WikusModelCard
    fullWidth
    elevation={0}
    avatar={
      <WikusAvatar size="large">
        {getInitials(customer.customerName)}
      </WikusAvatar>
    }
    details={[{
      label: intl.formatMessage({
        id: 'customers.details.customerNumber',
      }),
      value: customer.customerNumber,
    }, {
      label: intl.formatMessage({
        id: 'customers.details.addressNumber',
      }),
      value: customer.addressNumber,
    }]}
    title={customer.customerName}
  />
);

const renderTags = (value: any, getTagProps: any) =>
  value.map((option: any, index: number) => (
    <Chip style={{ height: '28px' }} variant="outlined" label={option.customerNumber} {...getTagProps({ index })} />
  ));

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    height: 'auto',
    minHeight: 48,
    flexWrap: 'wrap', // allow wrapping of chips
    alignItems: 'flex-start !important', // align input properly
    '& .MuiChip-root': {
      margin: theme.spacing(0.5, 0.25),
    },
  },
  inputLabel: {
    transform: 'translate(14px, 18px) scale(1)', // default MUI position +2px down
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)', // default shrunk position
    },
  },
  option: {
    padding: 0,
  },
}))

export const CustomerInput = ({ options, ...props }: { [key: string]: any, options: any[] }) => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      style={{ width: '100%' }}
      classes={{
        option: classes.option,
        inputRoot: classes.inputRoot,
      }}
      options={options}
      autoHighlight
      filterOptions={(options: Customer[], { inputValue }) => {
        if (!inputValue || !options?.length) {
          return options;
        }

        return filter(options, (o: Customer) => {
          return o.customerName?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
            || o.customerNumber?.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase());
        });
      }}
      getOptionLabel={getOptionLabel}
      renderOption={(o) => renderOption(o, intl)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={intl.formatMessage({ id: 'statistics.graph.customerIdsFilter' })}
          variant="outlined"
          InputLabelProps={{
            classes: { root: classes.inputLabel },
          }}
          placeholder={intl.formatMessage({ id: 'customer-customer.customers.label' })}
          inputProps={{
            ...params.inputProps,
            style: {
              width: '100%',
            },
            autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
      renderTags={renderTags}
      {...props}
    />
  );
};
